import { render, staticRenderFns } from "./ActiveSignals.vue?vue&type=template&id=36e6ac4b&scoped=true"
import script from "./ActiveSignals.vue?vue&type=script&lang=js"
export * from "./ActiveSignals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6ac4b",
  null
  
)

export default component.exports